



































































































import '@webcomponents/webcomponentsjs/webcomponents-bundle';
import { default as Component } from 'vue-class-component';
import StepperWidget from '@/components/widgets/elli-thg/StepperWidget.vue';
import ElliThgPrototype from '@/main/de/nonCommodity/ElliThgPrototype.vue';
import RegistrationWidget from '@/components/widgets/elli-thg/default/RegistrationWidget.vue';
import ProductWidget from '@/components/widgets/elli-thg/default/ProductWidget.vue';
import ReviewWidget from '@/components/widgets/elli-thg/default/ReviewWidget.vue';
import ContractWidget from '@/components/widgets/elli-thg/default/ContractWidget.vue';
import AlertWidget from '@/components/widgets/AlertWidget.vue';
import ModalWidget from '@/components/widgets/ModalWidget.vue';
import NotificationWidget from '@/components/widgets/NotificationWidget.vue';
import ReminderWidget from '@/components/widgets/ReminderWidget.vue';
import { Watch } from 'vue-property-decorator';
import IocContainer from '@/container/IocContainer';
import Tracking from '@/interfaces/Tracking';
import SERVICES from '@/container/Services';
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

// @WithRender
@Component({
  components: {
    'stepper-widget': StepperWidget,
    'product-widget': ProductWidget,
    'registration-widget': RegistrationWidget,
    'alert-widget': AlertWidget,
    'reminder-widget': ReminderWidget,
    'modal-widget': ModalWidget,
    'notification-widget': NotificationWidget,
    'contract-widget': ContractWidget,
    'review-widget': ReviewWidget
  }
})
export default class ElliThgDefault extends ElliThgPrototype {
  protected disableInitialProductLoading = true;

  @Watch('widgetsList', { deep: true })
  public handleSteps(value: { key: string; value: any }): void {
    let key: string | any = null;
    for (key in value) {
      if (value[key]) break;
    }
    switch (key) {
      case 'product':
        trackingProvider.thgFirstStep();
        break;
      case 'registration':
        trackingProvider.thgSecondStep();
        break;
      case 'contract':
        trackingProvider.thgThirdStep();
        break;
      case 'review':
        trackingProvider.thgFourthStep();
        break;
    }
  }

  public mounted(): void {
    trackingProvider.thgFirstStep();
  }

  public onCustomerTypeChanged() {
    this.data.loadingProducts = true;
  }

  public onCustomerTypeChangeError() {
    this.data.loadingProducts = false;
  }

  public onCustomerTypeSelected(customerType?: string) {
    this.data.loadingProducts = false;
    this.loadProducts();
  }
}
